import React from 'react'
import PropTypes from 'prop-types'
import DashTitleDivider from 'Components/DashTitleDivider'
import { SubPageBreadCrumbs } from 'Components/BreadCrumbs'

const AccountsPage = props => {
    return (
        <div>
            <SubPageBreadCrumbs />
            AccountsPage</div>
    )
}

AccountsPage.propTypes = {}

export default AccountsPage